import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectRegion } from "../features/counter/RegionSlice";
import Sales from "../Data/Sales";

import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

import { Box, Typography } from '@mui/material';
import config from "../config.js"

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const SalesData = () => {
  const region = useSelector(selectRegion);
  const [jsonData, setJsonData] = useState([]);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const filteredData =
      region === "All Region"
        ? Sales.Data
        : Sales.Data.filter((item) => item.Region === region);
    setJsonData(filteredData);
  }, [region]);

  useEffect(() => {
    setJsonData(Sales.Data);
  }, []);

  const data = {
    labels: jsonData.map((item) => item.Salesman),
    datasets: [
      {
        label: 'Sales',
        data: jsonData.map((item) => item.Sales),
        backgroundColor: 'purple',
      },
      {
        label: 'Sales per Hour',
        data: jsonData.map((item) => item["Sales Per Hour"]),
        backgroundColor: 'yellow',
      },
    ],
  };

  const options = {
    scales: {
      x: {
        stacked: true,
        ticks: {
          display: false,
        },
      },
      y: {
        stacked: true,
      },
    },
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">Sales Data - {region}</Typography>
        <Box display="flex" gap={2}>
          <Box display="flex" alignItems="center">
            <Box sx={{ width: 16, height: 16, backgroundColor: 'purple', mr: 1 }} />
            <Typography variant="body2">Sales</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Box sx={{ width: 16, height: 16, backgroundColor: 'yellow', mr: 1 }} />
            <Typography variant="body2">Sales per Hour</Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Bar data={data} options={options} />
      </Box>
    </Box>
  );
};

export default SalesData;
